import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router";

import { FullScreenLoader } from "@profitlens/ui/spinner";
import { useAuthStore } from "@/stores/auth-store";

/**
 * Route guard for /app/*: waits for the bootstrap decision, then either renders
 * or bounces to /login while remembering where the user wanted to go.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const status = useAuthStore((state) => state.status);
  const location = useLocation();

  if (status === "unknown" || status === "authenticating") {
    return <FullScreenLoader />;
  }

  if (status === "anonymous") {
    const from = `${location.pathname}${location.search}`;
    return <Navigate to="/login" replace state={{ from }} />;
  }

  return <>{children}</>;
}

/** Keeps signed-in users away from /login and /register. */
export function GuestOnly({ children }: { children: ReactNode }) {
  const status = useAuthStore((state) => state.status);

  if (status === "unknown" || status === "authenticating") {
    return <FullScreenLoader />;
  }

  if (status === "authenticated") {
    return <Navigate to="/app/dashboard" replace />;
  }

  return <>{children}</>;
}

export interface LoginLocationState {
  from?: string;
}
